import accessToken from 'utils/access-token'
import { SET_USER, SET_USER_COMPLETION, SET_TOKEN, SET_ROLES, SET_INFO, SET_USER_AVATAR, USER_SIGNOUT, UNREAD_MESSAGE, UNREAD_NOTICE } from 'utils/constant'
import roleResource from 'common/config/role-resource.js'

export default {
  state: {
    user: null,
    info: null,
    token: null,
    roles: null,
    resource: {},
    unreadMessage: null,
    unreadNotice: null,
    completion: {}
  },
  getters: {
    user: state => state['user'],
    completion: state => state['completion'],
    info: state => state['info'],
    token: state => state['token'],
    roles: state => state['roles'],
    resource: state => state['resource'],
    unreadMessage: state => state['unreadMessage'],
    unreadNotice: state => state['unreadNotice']
  },
  mutations: {
    [SET_USER](state, user) {
      state.user = user
    },
    [SET_INFO](state, info) {
      state.info = info
    },
    [SET_USER_COMPLETION](state, completion) {
      state.completion = completion
    },
    [USER_SIGNOUT](state) {
      accessToken.clean()
      state.user = null
      state.token = null
      state.roles = null
    },
    [SET_USER_AVATAR](state, avatar) {
      state.user.avatar = avatar
    },
    [SET_TOKEN](state, token) {
      state.token = token
      accessToken.set(token)
    },
    [SET_ROLES](state, payload) {
      const resource = {}
      // console.log(state, payload)
      payload.forEach((role) => {
        if (!roleResource[role]) return
        Object.keys(roleResource[role]).forEach((name) => {
          roleResource[role][name].forEach((operation) => {
            if (!resource[name]) {
              resource[name] = {}
            }
            resource[name][operation] = true
          })
        })
      })

      state.resource = resource
      state.roles = payload
    },
    [UNREAD_MESSAGE](state, unreadMessage) {
      state.unreadMessage = unreadMessage
    },
    [UNREAD_NOTICE](state, unreadNotice) {
      state.unreadNotice = unreadNotice
    }
  },
  actions: {
    [SET_USER]({commit}, user) {
      commit(SET_USER, user)
    },
    [SET_INFO]({commit}, info) {
      commit(SET_INFO, info)
    },
    [SET_USER_COMPLETION]({commit}, completion) {
      commit(SET_USER_COMPLETION, completion)
    },
    [SET_ROLES]({commit}, payload) {
      commit(SET_ROLES, payload)
    },
    [USER_SIGNOUT]({commit}) {
      commit(USER_SIGNOUT)
    },
    [SET_USER_AVATAR]({commit}, avatar) {
      commit(SET_USER_AVATAR, avatar)
    },
    [SET_TOKEN]({commit}, token) {
      commit(SET_TOKEN, token)
    },
    [UNREAD_MESSAGE]({commit}, unreadMessage) {
      commit(UNREAD_MESSAGE, unreadMessage)
    },
    [UNREAD_NOTICE]({commit}, unreadNotice) {
      commit(UNREAD_NOTICE, unreadNotice)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user/index.js